
import req from './http'
//定义接口  
class API {
  getBanner = params => req('get', 'api/v1/banner', params)
  getSaveData = params => req('post', 'api/v1/join/save', params)
  getPlanData = params => req('get', 'api/v1/join/plan', params)
  getDevelopData = params => req('get', 'api/v1/develop', params)
  getNewsListData = params => req('get', 'api/v1/news/list', params)
  getNewsTypeData = params => req('get', 'api/v1/news/type', params)
  getDetailsData = params => req('get', 'api/v1/news/details', params)
  getJobTypeData = params => req('get', 'api/v1/job/type', params)
  getJobListData = params => req('get', 'api/v1/job/list', params)
  getProductData = params => req('get', 'api/v1/product/list', params)
  getProductDetailsData = params => req('get', 'api/v1/product/details', params)
  getBgListData = params => req('get', 'api/v1/bg/list', params)
  getJobBetailsData = params => req('get', 'api/v1/details/id', params)
  getNewSaveData = params => req('post', 'api/v1/join/save_new', params)
  getNewSave2Data = params => req('post', 'api/v1/join/save_new2', params)
  getwxconfig = params => req('get', 'api/common/wechat/jssdk/config', params, 'act')
  //news/list /news/type' details
  // verify````````````````````````
  getVerifyCode = params => req('post', 'api/v1/sms/send', params, 'cont')                          //获取验证码
  getAreaCode = params => req('get', 'api/v1/sms/area_code_list', '', 'cont')                       //获取区号列表
  goLogin = params => req('post', 'api/v1/account/mobile_login', params, 'cont')                    //校验验证码
  getCertificate = params => req('post', 'api/v1/qrcode/scan_qrcode', params, 'cont')  //校验二维码
  getGoodsList = params => req('GET', 'api/v1/h5/goods/list', params, 'cont')                       //精品课
  getHelpsList = params => req('GET', 'api/v1/fission/list', params, 'cont')                       //助力课
  //~~~~~~~~~~~~~~~~~~~扭蛋机
  // 规矩
  get_activity_rule = params => req('get', 'api/v1/lottery/activity/info', params, 'cont')
  // 获得活动奖品列表
  get_activity_luck_draw = params => req('get', 'api/v1/lottery/prize/list', params, 'cont')
  // 获取当前用户(某活动)剩余的抽奖次数
  get_user_lottery_num = params => req('post', 'api/v1/lottery/get_user_lottery_num', params, 'cont')
  // 获取文章详情
  getAppArticleDetail = params => req('get', 'api/v1/article/detail', params,'cont')
}

export default new API()